import { getMeetingsData } from '@/apis/apis'
import useDocumentTitle from '@/components/Helmet'
import { useCustomLoader } from '@/components/Loader'
import CustomTable from '@/components/material/CustomTable'
import { Button } from '@/components/ui/button'
import { useToast } from '@/hooks/use-toast'
import { Box, Typography } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import MeetingAdd from './Add'

const MeetingList = () => {
    useDocumentTitle('Meetings');
    const {toast} = useToast();
    const loader = useCustomLoader();

    const [meetings, setMeetings] = useState({
        data: [],
        count: 0
    });
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [search, setSearch] = useState("");

    const [openAdd, setOpenAdd] = useState(false);

    const fetchMeetings = useCallback(async (search : string) => {
        loader(true);
        try {
            const data = await getMeetingsData({ page, limit, search });
            setMeetings(data);
        } catch (error: any) {
            toast({
                variant: "destructive",
                title: "Error!",
                description: error?.response?.data?.message || "Something went wrong",
            })
        } finally {
            loader(false);
        }
    }, [page, limit])

    useEffect(() => {
        const timer = setTimeout(async () => {
            fetchMeetings(search)
        }, search ? 600 : 0);
    },[search])
  return (
    <div>
        <Box sx={{display: "flex", justifyContent: "space-between"}}>
            <Typography variant="h6">Meetings</Typography>
            <Button onClick={() => setOpenAdd(true)}>Add Meeting</Button>
        </Box>

        <CustomTable
            data={meetings?.data || []}
            count={meetings?.count || 0}
            page={page}
            limit={limit}
            setPage={setPage}
            setLimit={setLimit}
            headers={[
                { id: "name", label: "Name" },
                { id: "date", label: "Date" },
                { id: "time", label: "Time" },
                { id: "location", label: "Location" },
                { id: "description", label: "Description" },
            ]}
        />

        {
            openAdd && <MeetingAdd openAdd={openAdd} setOpenAdd={setOpenAdd}/>
        }
    </div>
  )
}

export default MeetingList